import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Article } from "@domain/lms/article/article";
import { ArticleThumbnail } from "@ui/components/article/articleThumbnail";
import { Secondary } from "@ui/components/containers/textBlocks";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { desktop, gap, mobile } from "@ui/styles/utils";

interface FavoriteArticlesListProps extends React.HTMLAttributes<HTMLDivElement> {
	totalElements: number | undefined;
	articles: Article[];
	loading: boolean;
	moreLoading: boolean;
	fetchMore: () => Promise<void>;
}

export const FavoriteArticlesList: React.FC<FavoriteArticlesListProps> = ({
	totalElements = 0,
	articles,
	loading,
	moreLoading,
	fetchMore,
	...htmlProps
}) => {
	if (totalElements === 0) {
		return <Secondary>{I18n.t("profile.favorite.empty")}</Secondary>;
	}
	return (
		<InfiniteScroll onEndReached={fetchMore} loading={loading || moreLoading}>
			<Articles {...htmlProps}>
				{articles.map((article) => (
					<ArticleThumbnail key={article.id} article={article} />
				))}
				{loading && <ClipLoader />}
			</Articles>
		</InfiniteScroll>
	);
};

const Articles = styled.div`
	@media ${desktop} {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 20px;
	}
	@media ${mobile} {
		${gap(20)};
	}
`;
